// extracted by mini-css-extract-plugin
export default {"v-small":"(max-width: 480px)","v-med":"(max-width: 768px)","wrapper":"auth_dialog__wrapper__XBQjF"};